<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="header">
        <h1 class="title">开发者端</h1>
        <p class="subtitle">找回您的账号密码</p>
      </div>

      <el-form :model="forgetForm" :rules="rules" ref="loginFromRef" label-position="top">
        <div class="form-content">
          <el-form-item prop="email">
            <el-input 
              prefix-icon="el-icon-message"
              placeholder="注册邮箱地址" 
              v-model="forgetForm.email" 
              @input="changeInput">
            </el-input>
          </el-form-item>

          <el-form-item prop="code">
            <div class="captcha-container">
              <el-input
                prefix-icon="el-icon-key"
                placeholder="验证码"
                v-model="forgetForm.code"
                class="captcha-input"
                @input="changeInput">
              </el-input>
              <div class="captcha-img" v-html="code" @click="getCode" title="点击更换验证码"></div>
            </div>
          </el-form-item>

          <div class="action-links">
            <router-link to="/login">返回登录</router-link>
          </div>

          <el-form-item>
            <el-button type="primary" class="submit-btn" @click="forget">校验并找回</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      forgetForm: {
        email: "",
        code: "",
        type: "developer",
        sign:""
      },
      code:"",
      rules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: ["blur", "change"] },
          { min: 5, max: 40, message: "长度在 5 到 40 个字符", trigger: ["blur", "change"] },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
      },
    };
  },
  created() {
    this.getCode();
  },
  methods: {
    forget() {
      this.$refs.loginFromRef.validate(async (value) => {
        if (!value) return this.$message.error("请检查输入内容");
        const res = await this.$http.post("forget", this.forgetForm);
        console.log("忘记密码res:",res);
        if (res.data.meta.status !== 200) {
          this.getCode();
          return this.$message.error(res.data.meta.msg);
        } else {
          window.sessionStorage.setItem("forget", this.forgetForm.email);
          return this.$router.push("/forget/result");
        }
      });
    },
    async getCode() {
      // this.imgSrc = this.imgSrc = this.imgSrc+Date.parse(new Date())
      let result = await this.$http.get('getcode?' + Date.parse(new Date()))
      this.code = result.data.img
      this.forgetForm.sign = result.data.sign
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}


.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  box-sizing: border-box;
}

.header {
  text-align: center;
  margin-bottom: 30px;
  .title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    color: #909399;
  }
}

.captcha-container {
  display: flex;
  gap: 12px;
  .captcha-input { flex: 1; }
  .captcha-img {
    flex: 0 0 110px;
    height: 40px;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    /deep/ div, /deep/ svg {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.action-links {
  text-align: right;
  margin: -10px 0 20px 0;
  a {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
    font-weight: 500;
    &:hover { text-decoration: underline; }
  }
}

.submit-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  border-radius: 8px;
  letter-spacing: 2px;
}

.login_container {
  background-color: #2b4b6b;
  height: 100%;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items:center;/*垂直居中*/
  h4{
    margin: 20px 0;
  }
  a {
    text-decoration: none;
    color: #409eff;
    font-size: 15px;
  }
  .title {
    text-align: center;
    h2 {
      margin: 20;
    }
  }

  .el-form {
    // width: 400px;
    height: 380px;
    background-color: #fff;
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    border-radius: 5px;
    border-top: 1px solid;
    padding: 0 20px;
    .form-content {
      margin-top: 25px;
      .info {
        margin-top: -4px;
        display: flex;
        justify-content: space-between;
      }
    }
    .el-form-item {
      margin-top: 30px;
      .left,
      .code {
        float: left;
        width: 45%;
        height: 40px;
        img {
          // border: 1px solid #eee;
          width: 100%;
          height: 100%;
          // margin-left: 55px;
        }
        div {
          width: 100%;
          height: 100%;
          text-align: center;
          vertical-align: -9px;
          
        }
      }
      .el-button {
        float: right;
        margin-left: 20px;
        width: 100%;
        margin-top: -15px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  /deep/ .el-input__inner {
    font-size: 16px !important;
  }
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15vh;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    padding: 20px;
  }
}
</style>